import { RelacaoPagamentos } from "@/services/end-points/payments";
import { RelacaoPagamentosFormData, relacaoPagamentosSchema } from "../components/form-relacao-pagamentos/schemas";
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form";
import { DialogoLancamentoFormData } from "../relacao-pagamentos.types";

export function formatPaymentDate(dateStr: Date | string | null): string {
  if (!dateStr) return ""

  if (dateStr instanceof Date) {
    const year = dateStr.getFullYear()
    const month = String(dateStr.getMonth() + 1).padStart(2, "0")
    const day = String(dateStr.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split("/")
    return `${year}-${month}-${day}`
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return dateStr
  }

  const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`
  }

  return ""
}

export function mapDialogFormToPayment(fiscalDocUrl: string, data: DialogoLancamentoFormData): Partial<RelacaoPagamentos> {
  return {
    budget_item_id: Number(data.budget_item_id),
    amount: parseFloat(data.amount.replace(/\./g, "").replace(",", ".")) || 0,
    emission_type: data.emission_type,
    emission_number: data.emission_number,
    emission_date: data.emission_date,
    fiscal_note_url: fiscalDocUrl,
  }
}


type FormDataWithNormalizedDate = Omit<RelacaoPagamentosFormData, "payment_date" | "emission_date"> & {
  payment_date: string
  emission_date: Date | string
}

export function mapFormToPayloadSave(data: FormDataWithNormalizedDate): RelacaoPagamentos {
  return {
    id_staff_contract: Number(data.id_staff_contract) || 0,
    budget_item_id: Number(data.budget_item_id) || 0,
    installment_number: 0,
    due_date: data.payment_date,
    amount: parseFloat(data.amount.replace(/\./g, "").replace(",", ".")) || 0,
    paid_amount: 0,
    payment_date: data.payment_date,
    status: "",
    invoice_id: 0,
    fiscal_note_url: data.fiscal_note_url ?? "",
    fiscal_note_hashed: "",
    emission_type: data.emission_type,
    emission_number: data.emission_number,
    emission_date: typeof data.emission_date === "string" ? data.emission_date : data.emission_date.toISOString(),
    blockchain_tx_hash: "",
    blockchain_status: "",
  }
}

export function initFormRelacaoPagamentos(nomeProponente: string) {
  const form = useForm<RelacaoPagamentosFormData>({
    resolver: zodResolver(relacaoPagamentosSchema),
    defaultValues: {
      fiscal_note_url: "",
      id_staff_contract: "",
      budget_item_id: "",
      project: "",
      salic: "",
      proponent: nomeProponente,
      bank: "",
      agency: "",
      account: "",
      creditor: "",
      cpfCnpj: "",
      payment_date: "",
      emission_type: "",
      emission_number: "",
      emission_date: "",
      amount: "",
      notes: "",
    },
  })

  return form;
}